module.exports = __webpack_public_path__ + "static/img/1809102.650177a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/180910/1809102.jpg
// module id = nwbR
// module chunks = 0